import { useCallback, useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { api, apiError, isAdmin } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SEEN = "fm_heart_seen";

export const HeartButton = ({ onMessage }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const admin = isAdmin(user?.role);
  const [glow, setGlow] = useState(false);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/hearts/latest");
      if (data?.id && localStorage.getItem(SEEN) !== data.id) {
        localStorage.setItem(SEEN, data.id);
        setGlow(true);
        onMessage?.(data.message);
        setTimeout(() => setGlow(false), 60000);
      }
    } catch {
      /* tyst */
    }
  }, [onMessage]);

  useEffect(() => {
    check();
    const t = setInterval(check, 30000);
    return () => clearInterval(t);
  }, [check]);

  const send = async () => {
    try {
      const { data } = await api.post("/hearts");
      localStorage.setItem(SEEN, data.id);
      setGlow(true);
      onMessage?.(data.message);
      toast.success(t("heart.sent"));
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <button
      data-testid="heart-button"
      onClick={admin ? send : undefined}
      title={admin ? t("heart.send") : t("heart.receive")}
      className={`rounded-md p-2 transition-colors duration-200 ${
        glow ? "text-red-500" : "text-slate-400"
      } ${admin ? "hover:bg-red-50 hover:text-red-500" : "cursor-default"}`}
    >
      <Heart className={`h-5 w-5 ${glow ? "fill-red-500" : ""}`} data-testid={glow ? "heart-lit" : "heart-dim"} />
    </button>
  );
};

export default HeartButton;
